// export const rootUrl = 'http://localhost:8082/pos-main';
export const rootUrl = process.env['NX_STOREINFO_API_URL'] || 'http://localhost:8080';

export const surveyRootUrl = process.env['NX_SURVEY_API_URL'] || 'http://localhost:8090';

// export const sseRootUrl = process.env['NX_SSE_API_URL'] || 'http://localhost:8080';
